<template>
  <div class="RoomManagement">
    <el-form :inline="true"
             :model="searchForm"
             @keyup.enter.native="getDataList('search')">
      <el-form-item label="房间名称">
        <el-input v-model="searchForm.roomName"
                  placeholder="房间名称"></el-input>
      </el-form-item>
      <!--      <el-form-item label="房间类型">
              <el-select v-model="searchForm.apartmentAssetType">
                <el-option v-for="item in roomTypeList"
                           :key="item.value"
                           :label="item.label"
                           :value="item.value"/>
              </el-select>
            </el-form-item>
            <el-form-item label="房间状态">
              <el-select v-model="searchForm.apartmentAssetStatus">
                <el-option v-for="item in roomStateList"
                           :key="item.value"
                           :label="item.label"
                           :value="item.value"/>
              </el-select>
            </el-form-item>-->
      <el-form-item>
        <el-button icon="el-icon-search"
                   size="small"
                   type="primary"
                   @click="getDataList('search')">搜索
        </el-button>
        <el-button icon="el-icon-delete"
                   size="small"
                   plain
                   type="primary"
                   @click="reset()">清空
        </el-button>
      </el-form-item>
      <el-row>
        <el-col :span="12">
          <el-button icon="el-icon-plus"
                     size="small"
                     type="primary"
                     @click="openModifyDialog()">添加房间
          </el-button>

          <el-button icon="el-icon-plus"
                     size="small"
                     type="primary"
                     @click="openBatchAddRoomDialog()">批量添加房间
          </el-button>
        </el-col>
      </el-row>
    </el-form>

    <el-tabs v-model="activeName"
             @tab-click="handleClick"
             style="margin-top: 20px;">

      <el-tab-pane :label="item.apartmentName"
                   :name="String(item.apartmentId)"
                   v-for="(item, index) in apartmentList"
                   :key="index">

        <el-table class="dataTable"
                  v-loading="dataListLoading"
                  :data="dataList"
                  :header-cell-style="{'text-align':'center'}"
                  :cell-style="{'text-align':'center'}"
                  border>
          <el-table-column label="房间名称"
                           prop="roomName">
          </el-table-column>

 <!--         <el-table-column label="房间标签"
                           prop="roomLabel">
          </el-table-column>-->

          <el-table-column label="房间状态"
                           prop="rentedOut">
            <template slot-scope="scope">
              <span>{{ scope.row.rentedOut ? '入住' : '未入住' }}</span>
            </template>
          </el-table-column>

          <el-table-column label="房间租户"
                           prop="rentedUser">
          </el-table-column>

          <el-table-column label="创建时间"
                           prop="createTime">
          </el-table-column>

          <el-table-column label="操作"
                           width="500">
            <template slot-scope="scope">
              <!-- <el-button size="mini"
                         type="primary"
                         @click="openDetailDialog(scope.row)">添加设备</el-button> -->
              <el-button size="mini"
                         type="primary"
                         :disabled="scope.row.rentedOut"
                         @click="openAddTenantDialog(scope.row)">添加租户
              </el-button>
              <el-button size="mini"
                         type="primary"
                         @click="openDetailDialog(scope.row)">查看
              </el-button>
              <el-button size="mini"
                         type="primary"
                         :disabled="scope.row.rentedOut"
                         @click="openModifyDialog(scope.row)">编辑
              </el-button>
              <el-button size="mini"
                         type="danger"
                         :disabled="scope.row.rentedOut"
                         @click="handleDelete(scope.row)">删除
              </el-button>
              <el-button size="mini"
                         type="primary"
                         @click="openUserListDialog(scope.row)">成员
              </el-button>
              <el-button size="mini" type="primary" @click="openMpMsgDialog(scope.row)">发全员消息</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!--                       :page-sizes="[10, 20, 50, 100]"-->
        <!--                       @size-change="sizeChangeHandle"-->
        <el-pagination :current-page="pageIndex"
                       :page-size="pageSize"
                       :total="totalPage"
                       background
                       layout="total, sizes, prev, pager, next, jumper"
                       @current-change="currentChangeHandle">
        </el-pagination>
      </el-tab-pane>
    </el-tabs>

    <!-- 新增&修改房间信息 -->
    <el-dialog :title="modifyForm.roomId? '修改房间信息' : '添加房间'"
               :visible.sync="modifyDialog"
               width="40%"
               :before-close="cancelModifyDialog">
      <el-form class="modifyForm"
               ref="modifyForm"
               :model="modifyForm"
               :rules="modifyRule"
               label-width="40%">

        <el-form-item label="所属公寓"
                      prop="apartmentId">
          <el-select v-model="apartmentId" :disabled="modifyForm.roomId > 0">
            <el-option v-for="item in apartmentList"
                       :key="item.apartmentId"
                       :label="item.apartmentName"
                       :value="item.apartmentId"/>
          </el-select>
        </el-form-item>


        <el-form-item label="房间名称"
                      prop="name">
          <el-input style="width: 200px;"
                    v-model="modifyForm.roomName"
                    placeholder="请输入房间名称"
                    @keyup.enter.native="modifyHandle()"></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer"
            class="dialog-footer"
            style="display: flex;justify-content: space-between">
        <el-button @click="cancelModifyDialog()">取 消</el-button>
        <el-button type="primary"
                   @click="modifyHandle()">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 批量添加房间 -->
    <el-dialog title="批量添加房间"
               :visible.sync="batchAddRoomDialog"
               width="40%"
               :before-close="cancelBatchAddRoomDialog">
      <el-form class="batchAddRoomForm"
               ref="batchAddRoomForm"
               :model="batchAddRoomForm"
               :rules="batchAddRoomRule"
               label-width="40%">

        <el-form-item label="所属公寓"
                      prop="apartmentId">
          <el-select v-model="apartmentId">
            <el-option v-for="item in apartmentList"
                       :key="item.apartmentId"
                       :label="item.apartmentName"
                       :value="item.apartmentId"/>
          </el-select>
        </el-form-item>

        <el-form-item label="楼层"
                      prop="floor">
          <el-input-number v-model="batchAddRoomForm.floor" :min="1" :max="200" size="medium">1
          </el-input-number>
        </el-form-item>
        <el-form-item label="起始房号"
                      prop="start">
          <el-input-number v-model="batchAddRoomForm.start" :min="1" :max="200" size="medium">1
          </el-input-number>
        </el-form-item>
        <el-form-item label="房号步长"
                      prop="step">
          <el-input-number v-model="batchAddRoomForm.step" :min="1" :max="200" size="medium">1
          </el-input-number>
        </el-form-item>
        <el-form-item label="数量"
                      prop="qty">
          <el-input-number v-model="batchAddRoomForm.qty" :min="1" :max="50" size="medium">1
          </el-input-number>
        </el-form-item>


        <el-form-item label="房间名称前缀"
                      prop="prefix">
          <el-input style="width: 200px;"
                    v-model="batchAddRoomForm.prefix"
                    placeholder="请输入房间名称前缀"
                    @keyup.enter.native="batchAddRoomHandle()"></el-input>
        </el-form-item>

        <el-form-item label="房间名称后缀"
                      prop="suffix">
          <el-input style="width: 200px;"
                    v-model="batchAddRoomForm.suffix"
                    placeholder="请输入房间名称后缀"
                    @keyup.enter.native="batchAddRoomHandle()"></el-input>
        </el-form-item>

      </el-form>

      <span slot="footer"
            class="dialog-footer"
            style="display: flex;justify-content: space-between">
        <el-button @click="cancelBatchAddRoomDialog()">取 消</el-button>
        <el-button type="primary"
                   @click="batchAddRoomHandle()">确 定</el-button>
      </span>
    </el-dialog>


    <!-- 新增租户 -->
    <el-dialog title="添加租户"
               :visible.sync="addTenantDialog"
               width="40%"
               :before-close="cancelAddTenantDialog">
      <el-form class="addTenantForm"
               ref="addTenantForm"
               :model="addTenantForm"
               :rules="addTenantRule"
               label-width="40%">


        <el-form-item label="房间名称"
                      prop="name">
          <span>{{ addTenantForm.roomName }}</span>
        </el-form-item>

        <el-form-item label="租户姓名"
                      prop="userName">
          <el-input style="width: 200px;"
                    v-model="addTenantForm.userName"
                    placeholder="请输入租户姓名"
                    @keyup.enter.native="addTenant()"></el-input>
        </el-form-item>

        <el-form-item label="租户昵称"
                      prop="nickName">
          <el-input style="width: 200px;"
                    v-model="addTenantForm.nickName"
                    placeholder="请输入租户昵称"
                    @keyup.enter.native="addTenant()"></el-input>
        </el-form-item>

        <el-form-item label="租户手机号"
                      prop="userPhone">
          <el-input style="width: 200px;"
                    v-model="addTenantForm.userPhone"
                    placeholder="请输入租户手机号"
                    @keyup.enter.native="addTenant()"></el-input>
        </el-form-item>

        <el-form-item label="租户密码"
                      prop="userPassword">
          <el-input v-model="addTenantForm.userPassword"
                    placeholder="请输入密码"
                    style="width: 200px;"
                    type="password"
                    @keyup.enter.native="addTenant()"></el-input>
        </el-form-item>

      </el-form>
      <span slot="footer"
            class="dialog-footer"
            style="display: flex;justify-content: space-between">
        <el-button @click="cancelAddTenantDialog()">取 消</el-button>
        <el-button type="primary"
                   @click="addTenant()">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 房间信息详情 -->
    <el-dialog title="房间信息详情"
               :visible.sync="detailDialog"
               width="40%"
               :before-close="cancelDetailDialog">
      <el-form class="detailForm"
               ref="detailForm"
               :model="detailForm"
               label-width="40%">
        <el-form-item label="房间名称："
                      prop="roomName">
          <span>{{ detailForm.roomName }}</span>
        </el-form-item>
        <el-form-item label="房间标签："
                      prop="roomLabel">
          <span>{{ detailForm.roomLabel }}</span>
        </el-form-item>
        <el-form-item label="所属公寓："
                      prop="apartmentName">
          <span>{{ detailForm.apartmentName }}</span>
        </el-form-item>
        <el-form-item label="房东："
                      prop="landlord">
          <span>{{ detailForm.landlord }}</span>
        </el-form-item>
        <!--        <el-form-item label="房间类型："
                              prop="apartmentAssetType">
                  <span>{{ detailForm.apartmentAssetType == 1 ? '普通房间' : '公共房间' }}</span>
                </el-form-item>-->
        <el-form-item label="房间状态："
                      prop="rentedOut">
          <span>{{ detailForm.rentedOut ? '入住' : '未入住' }}</span>
        </el-form-item>

        <el-form-item label="租户："
                      v-if="detailForm.rentedUser"
                      prop="rentedUser">
          <span>{{ detailForm.rentedUser }}</span>
        </el-form-item>

      </el-form>
      <span slot="footer"
            class="dialog-footer"
            style="display: flex;justify-content: space-between">
        <el-button @click="cancelDetailDialog()">返 回</el-button>
      </span>
    </el-dialog>

    <!-- 房间成员 -->
    <el-dialog title="房间成员"
               width="60%"
               :visible.sync="userListDialogShow"
               :before-close="cancelUserListDialog">

      <span>公寓名称：{{ activeApartmentName }}</span><br>
      <span>房间名称：{{ activeRoomName }}</span>

      <el-table class="dataTable"
                v-loading="dataListLoading"
                :data="userList"
                height="400"
                :header-cell-style="{'text-align':'center'}"
                :cell-style="{'text-align':'center'}"
                border>
        <el-table-column label="用户名"
                         prop="userName">
        </el-table-column>

        <el-table-column label="手机号"
                         prop="userPhone">
        </el-table-column>

        <el-table-column label="角色"
                         prop="roleId">
          <template slot-scope="scope">
            <span>{{ scope.row.roleId == 3 ? '租户' : '住户' }}</span>
          </template>
        </el-table-column>

      </el-table>

    </el-dialog>

    <!-- 发全员消息 -->
    <el-dialog title="房间全员消息" :visible.sync="mpMsgDialog" width="40%"
               :before-close="cancelMpMsgDialog">
      <el-form class="mpMsgForm" ref="mpMsgForm" :model="mpMsgForm" :rules="mpMsgRule" label-width="40%">

        <el-form-item label="消息内容" prop="msgContent">
          <el-input style="width: 200px;" v-model="mpMsgForm.msgContent" placeholder="请输入内容名称"
                    @keyup.enter.native="mpMsgHandle()"></el-input>
        </el-form-item>

      </el-form>
      <span slot="footer" class="dialog-footer" style="display: flex;justify-content: space-between">
        <el-button @click="cancelMpMsgDialog()">取 消</el-button>
        <el-button type="primary" @click="mpMsgHandle()">发 送</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import '../assets/css/RoomManagement.css'
import util from "../utils/tools";

export default {
  data() {
    return {
      apartmentId: '',
      apartmentList: [],
      activeName: '',
      searchForm: {},
      roomTypeList: [
        {
          value: 1,
          label: '普通房间',
        },
        {
          value: 2,
          label: '公共房间',
        },
      ],
      roomStateList: [
        {
          value: 1,
          label: '未入住',
        },
        {
          value: 2,
          label: '入住',
        },
      ],
      roomEquipmentList: [],
      roomTenantList: [],
      dataListLoading: false,
      dataList: [],
      pageIndex: 1,
      pageSize: 20,
      totalPage: 0,
      modifyDialog: false,
      modifyForm: {roomId: 0},
      modifyRule: {
        apartmentAssetName: [
          {required: true, message: '房间名称不能为空', trigger: 'blur'},
        ],
        apartmentName: [
          {required: true, message: '所属公寓不能为空', trigger: 'blur'},
        ],
        apartmentAssetType: [
          {required: true, message: '请选择房间类型', trigger: 'blur'},
        ],
        apartmentAssetStatus: [
          {required: true, message: '请选择房间状态', trigger: 'blur'},
        ],
      },
      detailDialog: false,
      detailForm: {},
      addTenantDialog: false,
      addTenantForm: {},
      addTenantRule: {
        userName: [
          {required: true, message: '租户姓名不能为空', trigger: 'blur'},
        ],
        nickName: [
          {required: false, message: '---', trigger: 'blur'},
        ],
        userPhone: [
          {required: true, message: '租户手机号', trigger: 'blur'},
        ],
        userPassword: [
          {required: true, message: '租户密码', trigger: 'blur'},
        ],
      },

      activeApartmentName: '',
      activeRoomName: '',
      userListDialogShow: false,
      userList: [],

      batchAddRoomDialog: false,
      batchAddRoomForm: {floor: 1, start: 1, step: 1, qty: 1},
      batchAddRoomRule: {
        floor: [
          {required: true, message: '楼层不能为空', trigger: 'blur'},
        ],
        start: [
          {required: true, message: '起始房号不能为空', trigger: 'blur'},
        ],
        qty: [
          {required: true, message: '要创建的房间数量不能为空', trigger: 'blur'},
        ],
      },

      mpMsgDialog: false,
      mpMsgForm: {},
      mpMsgRule: {
        msgContent: [{
          required: true,
          message: '内容不能为空',
          trigger: 'blur'
        },],
      },
    }
  },

  computed: {},

  created() {
    let self = this

    self.getApartmentList()
  },

  mounted() {
  },

  methods: {
    handleClick(tab, event) {
      let self = this

      self.apartmentId = parseInt(tab.name)
      self.activeApartmentName = tab.label

      let str = {
        apartmentId: self.apartmentId,
        flag: 1,
        pageNo: 1,
        pageSize: self.pageSize,
      }
      self.getDataList('firstSearch', str)
    },
    // 清空查询条件
    reset() {
      let self = this
      Object.keys(self.searchForm).forEach((key) => (self.searchForm[key] = ''))
    },

    // 获取公寓列表
    getApartmentList() {
      let self = this

      self.$axios
        ._getApartmentList()
        .then((res) => {
          const datas = res.data

          if (datas.code == 0) {

            if (datas.data.apartmentList) {
              self.apartmentList = datas.data.apartmentList
            } else {
              self.$message.error('还没有创建公寓，不能加载房间')
              return
            }


            self.activeName = String(self.apartmentList[0].apartmentId)
            self.apartmentId = self.apartmentList[0].apartmentId
            self.activeApartmentName = self.apartmentList[0].apartmentName

            let str = {
              apartmentId: self.apartmentId,
              flag: 1,
              pageNo: 1,
              pageSize: self.pageSize,
            }
            self.getDataList('firstSearch', str)
          } else {
            self.$message.closeAll()
            self.$message.error(datas.msg)
          }
        })
        .catch((error) => {
          self.$message.closeAll()
          self.$message.error(datas.msg)
        })
    },

    // 获取房间列表
    getDataList(type, firstApartment) {
      let self = this

      self.dataListLoading = true

      let str = null

      if (type == 'firstSearch') {
        str = firstApartment
      } else {
        if (type == 'search') {
          self.pageIndex = 1
        }
        str = {
          apartmentId: self.apartmentId,
          roomName: self.searchForm.roomName,
          flag: 1,
          pageNo: self.pageIndex,
          pageSize: self.pageSize,
        }
      }

      self.$axios
        ._getRoomList(str)
        .then((res) => {
          self.dataListLoading = false
          const datas = res.data

          if (datas.code == 0) {
            self.dataList = datas.data.dataPage.records
            self.totalPage = datas.data.dataPage.total
          } else {
            self.$message.closeAll()
            self.$message.error(datas.msg)
          }
        })
        .catch((error) => {
          self.$message.closeAll()
          self.$message.error(datas.msg)
        })

    },

    // 每页数
    sizeChangeHandle(val) {
      let self = this

      self.pageSize = val
      self.pageIndex = 0
      self.getDataList()
    },

    // 当前页
    currentChangeHandle(val) {
      let self = this

      self.pageIndex = val
      self.getDataList()
    },

    // 打开 新增&修改弹窗
    openModifyDialog: function (row) {
      let self = this

      if (row) {
        let str = {
          roomId: row.roomId,
        }

        self.$axios
          ._getRoomInfo(str)
          .then((res) => {
            const datas = res.data

            if (datas.code == 0) {
              self.modifyForm = datas.data
            } else {
              self.$message.closeAll()
              self.$message.error(datas.msg)
            }
          })
          .catch((error) => {
            self.$message.closeAll()
            self.$message.error('系统异常，请联系管理员')
          })
      }

      // self.modifyForm.apartmentAssetStatus = 2
      self.modifyForm.apartmentId = self.apartmentId
      self.modifyDialog = true
    },

    // 新增&修改
    modifyHandle: function () {
      let self = this

      if (!self.modifyForm.apartmentId) {
        self.$message.error('请选择所属公寓')
        return
      }

      if (self.modifyForm.roomId) {
        let str = {
          roomId: self.modifyForm.roomId,
          roomName: self.modifyForm.roomName,
        }

        self.$axios
          ._putHomeInfo(str)
          .then((res) => {
            const datas = res.data
            if (datas.code == 0) {
              self.cancelModifyDialog()
              self.getDataList('search')
              self.$message.success('修改成功')
            } else {
              self.$message.closeAll()
              self.$message.error(datas.msg)
            }
          })
          .catch((error) => {
            self.$message.closeAll()
            self.$message.error('系统异常，请联系管理员')
          })
      } else {//新增房间
        let param = {
          apartmentId: self.modifyForm.apartmentId,
          roomName: self.modifyForm.roomName,
        }

        self.$axios
          ._addRoom(param)
          .then((res) => {
            const datas = res.data

            if (datas.code == 0) {
              self.cancelModifyDialog()
              self.apartmentId = String(self.modifyForm.apartmentId)
              self.getDataList('search')
              self.$message.success('添加成功')
            } else {
              self.$message.closeAll()
              self.$message.error(datas.msg)
            }
          })
          .catch((error) => {
            self.$message.closeAll()
            self.$message.error('系统异常，请联系管理员')
          })
      }
    },

    openBatchAddRoomDialog: function () {
      this.batchAddRoomDialog = true
      this.batchAddRoomForm.apartmentId = this.apartmentId
    },

    batchAddRoomHandle: function () {
      let self = this

      let param = {
        apartmentId: self.batchAddRoomForm.apartmentId,
        floor: self.batchAddRoomForm.floor,
        start: self.batchAddRoomForm.start,
        qty: self.batchAddRoomForm.qty,
        step: self.batchAddRoomForm.step,
      }

      if (self.batchAddRoomForm.suffix) {
        param.suffix = self.batchAddRoomForm.suffix
      }
      if (self.batchAddRoomForm.prefix) {
        param.prefix = self.batchAddRoomForm.prefix
      }

      self.$axios
        ._batchAddRoom(param)
        .then((res) => {
          const datas = res.data

          if (datas.code == 0) {
            self.cancelBatchAddRoomDialog()
            self.apartmentId = String(self.batchAddRoomForm.apartmentId)
            self.getDataList('search')
            self.$message.success(datas.data)
          } else {
            self.$message.closeAll()
            self.$message.error(datas.msg)
          }
        })
        .catch((error) => {
          self.$message.closeAll()
          self.$message.error('系统异常，请联系管理员')
        })
    },

    cancelBatchAddRoomDialog: function () {
      this.batchAddRoomDialog = false
    },

    // 关闭 新增&修改弹窗
    cancelModifyDialog: function () {
      let self = this

      Object.keys(self.modifyForm).forEach((key) => (self.modifyForm[key] = ''))
      self.$refs.modifyForm.resetFields()
      self.modifyDialog = false
    },

    //打开新增租户的dialog
    openAddTenantDialog: function (room) {
      let self = this
      self.addTenantDialog = true
      self.addTenantForm = {
        roomName: room.roomName,
        roomId: room.roomId,
      }
    },

    //为房间新增租户
    addTenant: function () {
      let self = this

      let param = {
        roomId: self.addTenantForm.roomId,
        userName: self.addTenantForm.userName,
        nickName: self.addTenantForm.nickName,
        userPhone: self.addTenantForm.userPhone,
        userPassword: self.addTenantForm.userPassword,
      }

      self.$axios
        ._landlordOrJanitorAddTenant(param)
        .then((res) => {
          const datas = res.data
          if (datas.code == 0) {
            self.cancelAddTenantDialog()
            self.getDataList('search')
            self.$message.success('修改成功')
          } else {
            self.$message.closeAll()
            self.$message.error(datas.msg)
          }
        })
        .catch((error) => {
          self.$message.closeAll()
          self.$message.error('系统异常，请联系管理员')
        })
    },

    //关闭新增租户
    cancelAddTenantDialog: function () {
      let self = this

      Object.keys(self.addTenantForm).forEach((key) => (self.addTenantForm[key] = ''))
      self.$refs.addTenantForm.resetFields()
      self.addTenantDialog = false
    },

    // 打开 房间信息弹窗
    openDetailDialog: function (row) {
      let self = this

      if (row) {
        let str = {
          roomId: row.roomId,
        }

        self.$axios
          ._getRoomInfo(str)
          .then((res) => {
            const datas = res.data

            if (datas.code == 0) {
              self.detailForm = datas.data
            } else {
              self.$message.closeAll()
              self.$message.error(datas.msg)
            }
          })
          .catch((error) => {
            self.$message.closeAll()
            self.$message.error('系统异常，请联系管理员')
          })
      }

      self.detailDialog = true
    },

    // 关闭 房间信息弹窗
    cancelDetailDialog: function () {
      let self = this

      Object.keys(self.detailForm).forEach((key) => (self.detailForm[key] = ''))

      self.detailDialog = false
    },

    // 删除房间
    handleDelete(row) {
      let self = this

      let str = {roomId: row.roomId}
      self
        .$confirm(`是否确认要删除 "${row.roomName}" 房间`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then(function () {
          return self.delHome(str)
        })
        .then((data) => {
        })
    },

    openUserListDialog(row) {
      let self = this
      self.userListDialogShow = true
      self.dataListLoading = true
      self.activeRoomName = row.roomName

      let str = {
        roomId: row.roomId,
      }

      self.$axios
        ._getRoomUserList(str)
        .then((res) => {
          const datas = res.data

          self.dataListLoading = false

          if (datas.code == 0) {
            self.userList = datas.data
          } else {
            self.$message.closeAll()
            self.$message.error(datas.msg)
          }
        })
        .catch((error) => {
          self.$message.closeAll()
          self.$message.error('系统异常，请联系管理员')
        })
    },

    cancelUserListDialog() {
      let self = this

      self.userListDialogShow = false
    },

    openMpMsgDialog(item) {
      this.mpMsgForm = util.deepCopy(item)
      this.mpMsgDialog = true
    },
    cancelMpMsgDialog() {
      this.mpMsgDialog = false
    },
    mpMsgHandle: function () {
      let self = this

      let msgContent = self.mpMsgForm.msgContent

      if(msgContent == undefined || msgContent.length == 0){
        alert("内容不能为空")
        return
      }

      let param = {
        msgType: 0,//ui消息的类型，目前不校验
        msgContent: msgContent,
        msgReceiverType: 2,//1公寓成员；2房间成员
        roomId: this.mpMsgForm.roomId
      }


      self.$axios
        ._sendUiMsg(param)
        .then((res) => {
          const datas = res.data
          if (datas.code == 0) {
            self.cancelMpMsgDialog()
            self.$message.success('发送成功')
          } else {
            self.$message.closeAll()
            self.$message.error(datas.msg)
          }
        })
        .catch((error) => {
          self.$message.closeAll()
          self.$message.error('系统异常，请稍后重试')
        })


    },

    delHome(str) {
      let self = this

      self.$axios
        ._deleteNoRentedOutRoom(str)
        .then((res) => {
          const datas = res.data

          if (datas.code == 0) {
            self.$message.success('删除成功')
            self.getDataList('search')
          } else {
            self.$message.closeAll()
            self.$message.error(datas.msg)
          }
        })
        .catch((error) => {
          self.$message.closeAll()
          self.$message.error(datas.msg)
        })

      self.dataListLoading = false
    },
  },
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/RoomManagement.vue